// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================================
   MODERN DIALOGS - COMPLETE STYLING
   ===================================================== */

/* Base dialog styling */
.modern-dialog {
  width: 600px;
  max-width: 95vw;
  border-radius: 12px;
  overflow: hidden;
}

/* Toolbar styling */
.modern-dialog md-toolbar {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
}

.modern-dialog md-toolbar h2 {
  color: white;
  font-weight: 600;
  font-size: 18px;
  margin: 0;
}

.modern-dialog md-toolbar .md-icon-button {
  color: white;
  transition: transform 0.2s ease;
}

.modern-dialog md-toolbar .md-icon-button:hover {
  transform: scale(1.1);
}

/* Content area */
.modern-dialog md-dialog-content {
  padding: 32px 24px;
  background-color: #fafafa;
}

/* Actions area */
.modern-dialog md-dialog-actions {
  padding: 16px 24px;
  background-color: #f5f5f5;
  border-top: 1px solid #e0e0e0;
}

/* Button styling */
.modern-dialog md-button {
  border-radius: 6px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.2s ease;
}

.modern-dialog md-button.md-raised {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.modern-dialog md-button.md-raised:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}

.modern-dialog md-button md-icon {
  margin-right: 6px;
  font-size: 20px;
}

/* =====================================================
   ERROR DIALOG
   ===================================================== */

.error-dialog md-toolbar {
  background: linear-gradient(135deg, #f44336 0%, #e53935 100%);
}

.error-dialog .icon-wrapper {
  background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);
  border-radius: 50%;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  box-shadow: 0 4px 20px rgba(244, 67, 54, 0.2);
  animation: pulse-error 2s ease-in-out infinite;
}

@keyframes pulse-error {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 4px 20px rgba(244, 67, 54, 0.2);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 8px 30px rgba(244, 67, 54, 0.3);
  }
}

.error-dialog .message-box {
  background-color: #ffebee;
  border: 2px solid #ef5350;
  border-radius: 8px;
  padding: 16px 20px;
  max-width: 500px;
  width: 100%;
}

.error-dialog md-button.md-warn {
  background-color: #f44336;
  color: white;
}

.error-dialog md-button.md-warn:hover {
  background-color: #e53935;
  box-shadow: 0 4px 8px rgba(244, 67, 54, 0.3);
}

/* =====================================================
   SUCCESS DIALOG
   ===================================================== */

.success-dialog md-toolbar {
  background: linear-gradient(135deg, #4caf50 0%, #43a047 100%);
}

.success-dialog .icon-wrapper {
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
  border-radius: 50%;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  box-shadow: 0 4px 20px rgba(76, 175, 80, 0.2);
  animation: pulse-success 2s ease-in-out infinite;
}

@keyframes pulse-success {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 4px 20px rgba(76, 175, 80, 0.2);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 8px 30px rgba(76, 175, 80, 0.3);
  }
}

.success-dialog md-button {
  background-color: #4caf50;
  color: white;
}

.success-dialog md-button:hover {
  background-color: #43a047;
  box-shadow: 0 4px 8px rgba(76, 175, 80, 0.3);
}

/* =====================================================
   DECISION DIALOG
   ===================================================== */

.decision-dialog md-toolbar {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
}

.decision-dialog .icon-wrapper {
  background: linear-gradient(135deg, #fff3cd 0%, #ffe8a1 100%);
  border-radius: 50%;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  box-shadow: 0 4px 20px rgba(255, 193, 7, 0.2);
  animation: pulse-warning 2s ease-in-out infinite;
}

@keyframes pulse-warning {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 4px 20px rgba(255, 193, 7, 0.2);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 8px 30px rgba(255, 193, 7, 0.3);
  }
}

.decision-dialog md-dialog-actions {
  gap: 12px;
}

.decision-dialog .go-back-btn {
  background-color: #757575;
  color: white;
}

.decision-dialog .go-back-btn:hover {
  background-color: #616161;
}

.decision-dialog md-button.md-warn {
  background-color: #d32f2f;
  color: white;
}

.decision-dialog md-button.md-warn:hover {
  background-color: #c62828;
  box-shadow: 0 4px 8px rgba(211, 47, 47, 0.3);
}

/* =====================================================
   INFORMATION DIALOG
   ===================================================== */

.information-dialog md-toolbar {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
}

.information-dialog .icon-wrapper {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 50%;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  box-shadow: 0 4px 20px rgba(33, 150, 243, 0.2);
  animation: pulse-info 2s ease-in-out infinite;
}

@keyframes pulse-info {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 4px 20px rgba(33, 150, 243, 0.2);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 8px 30px rgba(33, 150, 243, 0.3);
  }
}

.information-dialog md-button {
  background-color: #2196f3;
  color: white;
}

.information-dialog md-button:hover {
  background-color: #1976d2;
  box-shadow: 0 4px 8px rgba(33, 150, 243, 0.3);
}

/* =====================================================
   RESPONSIVE
   ===================================================== */

@media (max-width: 600px) {
  .modern-dialog {
    width: 100vw;
    max-width: 100vw;
    border-radius: 0;
  }

  .modern-dialog md-dialog-content {
    padding: 24px 16px;
  }

  .modern-dialog .icon-wrapper {
    width: 80px;
    height: 80px;
  }

  .modern-dialog .icon-wrapper md-icon {
    font-size: 48px !important;
    width: 48px !important;
    height: 48px !important;
  }

  .modern-dialog md-button {
    min-width: 90px;
    font-size: 13px;
  }

  .decision-dialog md-dialog-actions {
    flex-direction: column-reverse;
    gap: 8px;
  }

  .decision-dialog md-dialog-actions md-button {
    width: 100%;
  }

  .error-dialog .message-box {
    padding: 12px 16px;
  }
}

/* =====================================================
   ACCESSIBILITY & POLISH
   ===================================================== */

/* Focus states */
.modern-dialog md-button:focus {
  outline: 2px solid rgba(0, 0, 0, 0.2);
  outline-offset: 2px;
}

/* Smooth transitions */
.modern-dialog * {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

/* Text styling */
.modern-dialog p {
  font-family: 'Roboto', sans-serif;
}

/* Icon sizing consistency */
.modern-dialog .icon-wrapper md-icon {
  font-size: 56px;
  width: 56px;
  height: 56px;
}`, "",{"version":3,"sources":["webpack://./common/dialog/dialog.css"],"names":[],"mappings":"AAAA;;0DAE0D;;AAE1D,wBAAwB;AACxB;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;0DAE0D;;AAE1D;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,6CAA6C;EAC7C,8CAA8C;AAChD;;AAEA;EACE;IACE,mBAAmB;IACnB,6CAA6C;EAC/C;EACA;IACE,sBAAsB;IACtB,6CAA6C;EAC/C;AACF;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;;0DAE0D;;AAE1D;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,6CAA6C;EAC7C,gDAAgD;AAClD;;AAEA;EACE;IACE,mBAAmB;IACnB,6CAA6C;EAC/C;EACA;IACE,sBAAsB;IACtB,6CAA6C;EAC/C;AACF;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;;0DAE0D;;AAE1D;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,6CAA6C;EAC7C,gDAAgD;AAClD;;AAEA;EACE;IACE,mBAAmB;IACnB,6CAA6C;EAC/C;EACA;IACE,sBAAsB;IACtB,6CAA6C;EAC/C;AACF;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;;0DAE0D;;AAE1D;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,8CAA8C;EAC9C,6CAA6C;AAC/C;;AAEA;EACE;IACE,mBAAmB;IACnB,8CAA8C;EAChD;EACA;IACE,sBAAsB;IACtB,8CAA8C;EAChD;AACF;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;;0DAE0D;;AAE1D;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,8BAA8B;IAC9B,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;;0DAE0D;;AAE1D,iBAAiB;AACjB;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,wDAAwD;AAC1D;;AAEA,iBAAiB;AACjB;EACE,iCAAiC;AACnC;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd","sourcesContent":["/* =====================================================\n   MODERN DIALOGS - COMPLETE STYLING\n   ===================================================== */\n\n/* Base dialog styling */\n.modern-dialog {\n  width: 600px;\n  max-width: 95vw;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n/* Toolbar styling */\n.modern-dialog md-toolbar {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  flex-shrink: 0;\n}\n\n.modern-dialog md-toolbar h2 {\n  color: white;\n  font-weight: 600;\n  font-size: 18px;\n  margin: 0;\n}\n\n.modern-dialog md-toolbar .md-icon-button {\n  color: white;\n  transition: transform 0.2s ease;\n}\n\n.modern-dialog md-toolbar .md-icon-button:hover {\n  transform: scale(1.1);\n}\n\n/* Content area */\n.modern-dialog md-dialog-content {\n  padding: 32px 24px;\n  background-color: #fafafa;\n}\n\n/* Actions area */\n.modern-dialog md-dialog-actions {\n  padding: 16px 24px;\n  background-color: #f5f5f5;\n  border-top: 1px solid #e0e0e0;\n}\n\n/* Button styling */\n.modern-dialog md-button {\n  border-radius: 6px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  transition: all 0.2s ease;\n}\n\n.modern-dialog md-button.md-raised {\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.modern-dialog md-button.md-raised:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n  transform: translateY(-1px);\n}\n\n.modern-dialog md-button md-icon {\n  margin-right: 6px;\n  font-size: 20px;\n}\n\n/* =====================================================\n   ERROR DIALOG\n   ===================================================== */\n\n.error-dialog md-toolbar {\n  background: linear-gradient(135deg, #f44336 0%, #e53935 100%);\n}\n\n.error-dialog .icon-wrapper {\n  background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);\n  border-radius: 50%;\n  width: 100px;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n  box-shadow: 0 4px 20px rgba(244, 67, 54, 0.2);\n  animation: pulse-error 2s ease-in-out infinite;\n}\n\n@keyframes pulse-error {\n  0%, 100% {\n    transform: scale(1);\n    box-shadow: 0 4px 20px rgba(244, 67, 54, 0.2);\n  }\n  50% {\n    transform: scale(1.05);\n    box-shadow: 0 8px 30px rgba(244, 67, 54, 0.3);\n  }\n}\n\n.error-dialog .message-box {\n  background-color: #ffebee;\n  border: 2px solid #ef5350;\n  border-radius: 8px;\n  padding: 16px 20px;\n  max-width: 500px;\n  width: 100%;\n}\n\n.error-dialog md-button.md-warn {\n  background-color: #f44336;\n  color: white;\n}\n\n.error-dialog md-button.md-warn:hover {\n  background-color: #e53935;\n  box-shadow: 0 4px 8px rgba(244, 67, 54, 0.3);\n}\n\n/* =====================================================\n   SUCCESS DIALOG\n   ===================================================== */\n\n.success-dialog md-toolbar {\n  background: linear-gradient(135deg, #4caf50 0%, #43a047 100%);\n}\n\n.success-dialog .icon-wrapper {\n  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);\n  border-radius: 50%;\n  width: 100px;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n  box-shadow: 0 4px 20px rgba(76, 175, 80, 0.2);\n  animation: pulse-success 2s ease-in-out infinite;\n}\n\n@keyframes pulse-success {\n  0%, 100% {\n    transform: scale(1);\n    box-shadow: 0 4px 20px rgba(76, 175, 80, 0.2);\n  }\n  50% {\n    transform: scale(1.05);\n    box-shadow: 0 8px 30px rgba(76, 175, 80, 0.3);\n  }\n}\n\n.success-dialog md-button {\n  background-color: #4caf50;\n  color: white;\n}\n\n.success-dialog md-button:hover {\n  background-color: #43a047;\n  box-shadow: 0 4px 8px rgba(76, 175, 80, 0.3);\n}\n\n/* =====================================================\n   DECISION DIALOG\n   ===================================================== */\n\n.decision-dialog md-toolbar {\n  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);\n}\n\n.decision-dialog .icon-wrapper {\n  background: linear-gradient(135deg, #fff3cd 0%, #ffe8a1 100%);\n  border-radius: 50%;\n  width: 100px;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n  box-shadow: 0 4px 20px rgba(255, 193, 7, 0.2);\n  animation: pulse-warning 2s ease-in-out infinite;\n}\n\n@keyframes pulse-warning {\n  0%, 100% {\n    transform: scale(1);\n    box-shadow: 0 4px 20px rgba(255, 193, 7, 0.2);\n  }\n  50% {\n    transform: scale(1.05);\n    box-shadow: 0 8px 30px rgba(255, 193, 7, 0.3);\n  }\n}\n\n.decision-dialog md-dialog-actions {\n  gap: 12px;\n}\n\n.decision-dialog .go-back-btn {\n  background-color: #757575;\n  color: white;\n}\n\n.decision-dialog .go-back-btn:hover {\n  background-color: #616161;\n}\n\n.decision-dialog md-button.md-warn {\n  background-color: #d32f2f;\n  color: white;\n}\n\n.decision-dialog md-button.md-warn:hover {\n  background-color: #c62828;\n  box-shadow: 0 4px 8px rgba(211, 47, 47, 0.3);\n}\n\n/* =====================================================\n   INFORMATION DIALOG\n   ===================================================== */\n\n.information-dialog md-toolbar {\n  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);\n}\n\n.information-dialog .icon-wrapper {\n  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);\n  border-radius: 50%;\n  width: 100px;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n  box-shadow: 0 4px 20px rgba(33, 150, 243, 0.2);\n  animation: pulse-info 2s ease-in-out infinite;\n}\n\n@keyframes pulse-info {\n  0%, 100% {\n    transform: scale(1);\n    box-shadow: 0 4px 20px rgba(33, 150, 243, 0.2);\n  }\n  50% {\n    transform: scale(1.05);\n    box-shadow: 0 8px 30px rgba(33, 150, 243, 0.3);\n  }\n}\n\n.information-dialog md-button {\n  background-color: #2196f3;\n  color: white;\n}\n\n.information-dialog md-button:hover {\n  background-color: #1976d2;\n  box-shadow: 0 4px 8px rgba(33, 150, 243, 0.3);\n}\n\n/* =====================================================\n   RESPONSIVE\n   ===================================================== */\n\n@media (max-width: 600px) {\n  .modern-dialog {\n    width: 100vw;\n    max-width: 100vw;\n    border-radius: 0;\n  }\n\n  .modern-dialog md-dialog-content {\n    padding: 24px 16px;\n  }\n\n  .modern-dialog .icon-wrapper {\n    width: 80px;\n    height: 80px;\n  }\n\n  .modern-dialog .icon-wrapper md-icon {\n    font-size: 48px !important;\n    width: 48px !important;\n    height: 48px !important;\n  }\n\n  .modern-dialog md-button {\n    min-width: 90px;\n    font-size: 13px;\n  }\n\n  .decision-dialog md-dialog-actions {\n    flex-direction: column-reverse;\n    gap: 8px;\n  }\n\n  .decision-dialog md-dialog-actions md-button {\n    width: 100%;\n  }\n\n  .error-dialog .message-box {\n    padding: 12px 16px;\n  }\n}\n\n/* =====================================================\n   ACCESSIBILITY & POLISH\n   ===================================================== */\n\n/* Focus states */\n.modern-dialog md-button:focus {\n  outline: 2px solid rgba(0, 0, 0, 0.2);\n  outline-offset: 2px;\n}\n\n/* Smooth transitions */\n.modern-dialog * {\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Text styling */\n.modern-dialog p {\n  font-family: 'Roboto', sans-serif;\n}\n\n/* Icon sizing consistency */\n.modern-dialog .icon-wrapper md-icon {\n  font-size: 56px;\n  width: 56px;\n  height: 56px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
